import React, { useState, useEffect } from "react";
import { Card, Grid } from "@material-ui/core";
import { CardBody, CardHeader, CardTitle, Input } from "reactstrap";
import "./Department.css";
import img1 from "../../assets/ivy_logo.png";
import Button from "../../Components/Button";
import { useNavigate } from "react-router-dom";

import { Link } from "react-router-dom";
import {
  Progress,
  Modal,
  ModalHeader,
  ModalFooter,
  Form,
  ModalBody,
} from "reactstrap";
import Swal from "sweetalert2";
import axios from "axios";
import { tabClasses } from "@mui/material";
import Tables from "../../Components/Tables";

function Departmentticket(props: any) {
  const [tickets, setTickets] = useState([]);
  const navigate = useNavigate();

  const [department, setDeparment] = useState("");
  const [modal, setModal] = useState(false);
  const [role, setRole] = useState("");
  const [show, setShow] = useState(false);
  const [description, setDescription] = useState("");
  const [progress, setProgress] = useState(0);
  const [p, setP] = useState(false);

  const [attachments, setAttachments] = useState<any>([]);
  const handleAddOpenFile = () => {
    setProgress(0);
    setShow(false);
    setDescription("");
    setModal(true);
  };

  return (
    <div>
      <Link
        style={{ marginTop: "2%" }}
        to="/"
        className="btn btn-secondary mb-3"
      >
        <i className="fa fa-arrow-left" aria-hidden="true" />
      </Link>
      {props.user?.role_id === "1" ? (
        <Tables user={props?.user} style={{ textAlign: "center" }} />
      ) : (
        <Tables
          departmentid={props?.departmentId ?? ""}
          user={props?.user}
          style={{ textAlign: "center" }}
        />
      )}
    </div>
  );
}

export default Departmentticket;
